export default {
  colors: ['#c80a19', '#fff200', '#7fffd4'],
  opacities: [1 / 3, 2 / 3, 1],
  widths: [2, 5, 13],
  tools: ['pencil', 'arrow', 'circle', 'line', 'text', 'eraser'],
}
